// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1hA1y","signatureButtonsRight":"ModalSign_signatureButtonsRight__1-4a_"};